import { useState, useRef } from 'react';
import { useClickOutside } from '@/hooks/useClickOutside';
import CircleThreeDotsIcon from '@/assets/icons/circle-three-dots.svg?react';
import ThreeDotsIcon from '@/assets/icons/three-dots.svg?react';
import styles from './PopoverMenu.module.scss';

interface ISetMenu {
  index: number;
  defaultIcon: boolean;
  // onRemoveOptions: () => void;
  onRemoveFromSet?: () => void;
  onDelete?: () => void;
  onShowHistory: () => void;
  showHistory?: boolean; // need a flag since it depends on user permissions
}

function SetMenu({ index, defaultIcon, onRemoveFromSet, onDelete, onShowHistory, showHistory }: ISetMenu) {
  const [showMenuId, setShowMenuId] = useState<number | null>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  useClickOutside(menuRef, showMenuId, () => setShowMenuId(null));

  const handleRemoveFromSet = () => {
    setShowMenuId(null); // reset menu popover
    onRemoveFromSet?.();
  };

  const handleDelete = () => {
    setShowMenuId(null); // reset menu popover
    onDelete?.();
  };

  const handleHistory = () => {
    setShowMenuId(null);
    onShowHistory?.();
  };

  return (
    <div className={styles.menu} ref={showMenuId === index ? menuRef : null}>
      <button type="button" className={styles.menuButton} aria-label="Open set options menu" onClick={() => setShowMenuId(index)}>
        {defaultIcon ? <CircleThreeDotsIcon aria-hidden="true" className={styles.menuIcon} /> : <ThreeDotsIcon aria-hidden="true" className={styles.menuIcon} />}
      </button>
      {showMenuId === index && (
        <div className={`${styles.menuPopover} ${styles.setPopover}`}>
          {/* <span role="button" onClick={handleRemoveOptions}>
            Remove Options
          </span> */}
          <span role="button" onClick={handleRemoveFromSet}>
            Remove from Set
          </span>
          <span role="button" onClick={handleDelete}>
            Delete Club
          </span>
          {showHistory && (
            <span role="button" onClick={handleHistory}>
              History
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export default SetMenu;
